import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Document, Page, pdfjs } from 'react-pdf';
import './Home.css';

// Configure PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

function Home() {
  const navigate = useNavigate();
  const [tapCount, setTapCount] = useState(0);
  const [tapTimer, setTapTimer] = useState(null);

  const handleSecretTap = () => {
    // Clear any existing timer
    if (tapTimer) {
      clearTimeout(tapTimer);
    }

    const newCount = tapCount + 1;
    setTapCount(newCount);

    // If 5 taps, navigate to admin login
    if (newCount >= 5) {
      setTapCount(0);
      navigate('/admin/login');
      return;
    }

    // Reset counter after 2 seconds of no taps
    const timer = setTimeout(() => {
      setTapCount(0);
    }, 2000);
    setTapTimer(timer);
  };

  return (
    <div className="home">
      {/* Background Falling Leaves */}
      {[...Array(10)].map((_, i) => (
        <div key={i} className="leaf"></div>
      ))}

      <div className="home-hero">
        <div className="home-pdf-container" onClick={handleSecretTap} style={{ cursor: 'default' }}>
          <Document
            file="/wedding-invitation.pdf"
            loading={<div className="pdf-loading">Loading...</div>}
            error={<div className="pdf-error">Failed to load invitation</div>}
          >
            <Page
              pageNumber={1}
              width={Math.min(window.innerWidth * 0.9, 800)}
              renderTextLayer={false}
              renderAnnotationLayer={false}
            />
          </Document>
        </div>
      </div>

      {/* Foreground Falling Leaves - appear above the PDF */}
      {[...Array(5)].map((_, i) => (
        <div key={`front-${i}`} className="leaf-front"></div>
      ))}
    </div>
  );
}

export default Home;
